var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBigBBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 329,
    height: 375,
    fill: "none",
    viewBox: "0 0 329 375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFCB21",
    strokeLinejoin: "round",
    strokeWidth: 2.65,
    d: "M261.168 347.357c-22.736 8.878-70.727 17.697-113.978 22.676-38.333 4.679-73.366 5.279-86.924-4.259-12.957-9.179-20.756-42.472-27.174-79.545-2.58-14.937-4.74-30.414-7.319-45.291L7.057 132.778c-5.58-32.214-9.959-66.107 1.2-78.945C31.351 27.02 144.07-2.916 196.92 1.823c40.732 3.36 74.386 26.275 84.044 59.269 8.639 29.694 3.06 66.347-10.738 78.165 22.556 9.958 47.751 38.273 54.11 74.866 10.258 59.148-6.599 110.618-63.108 133.294zM145.27 118.261c8.159-1.44 15.897-8.218 14.337-17.337-.24-1.44-.959-2.82-1.859-5.159-3.6-6.299-9.418-8.758-15.237-7.738-8.159 1.44-15.237 9.058-13.798 17.756l.6 3.36c2.88 7.918 9.718 10.198 15.957 9.118Zm28.255 149.191c7.678-1.319 15.897-8.218 14.397-16.856-.36-1.92-1.08-3.3-1.86-5.099-4.139-6.719-10.378-8.639-16.197-7.619-7.678 1.32-15.357 8.638-13.797 17.757.18.96.84 1.859.96 2.819 2.939 8.459 9.718 10.198 16.437 9.058z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigBBlue);
export default __webpack_public_path__ + "static/media/big-b-blue.c37b6a4ba9a2896c8310e10cba46b9d6.svg";
export { ForwardRef as ReactComponent };